import { isNativeMobile } from '@droplet-tech-code/core-elements/module/utils/utils.helper';

import { PageHeader } from '~/components/Page/Page.Header';
import { translate } from '~/utils/translation.utils';

import { useAddAreaLocation } from './AreaLocations.Add';

export const AreaLocationListHeader = () => {
  const { openModal: openAddModal } = useAddAreaLocation();

  return (
    <PageHeader
      title={translate('areaLocations.areaLocations')}
      withBack={isNativeMobile}
      iconRight={{
        color: 'monochrome',
        icon: 'plus',
        onPress: () => openAddModal(),
      }}
    />
  );
};
